import { requests } from "../../utils/api/api.service";
import { SETTINGS_URL } from "../../utils/api/endpoints";
import { ISetting } from "../../shared/interfaces/setting/ISetting";

export const SettingsService = {
  get: (): Promise<{ data: ISetting }> => requests.get(SETTINGS_URL),
  update: (payload: ISetting): Promise<ISetting> => requests.put(SETTINGS_URL, payload),
};
